import { Fragment, useState } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
// import { useState } from 'react'
import { useEffect } from 'react'

const navigation = [
  { name: 'Home', href: '/', current: true },
  { name: 'Learn', href: '/Blogs', current: true },
  { name: 'Tools', href: '/Tools', current: true },
  { name: 'About', href: '/About', current: true },
  { name: 'Add Data', href: '/Admin', current: true },

]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Example() {
const [data,setData]=useState(null);

  useEffect(() => {
    fetch("https://finhunttbackend-production.up.railway.app/ap")
      .then((res) => res.json())
      .then((data) => setData(data.message));
  }, []);


  return (
    <Disclosure as="nav" className="bg-gray-800 ">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-end sm:justify-between px-3 no-underline">
                <div className="navbar_left flex flex-shrink-0 items-center gap-3 font-bold  text-white ">
                  <img
                    className="block h-8 w-auto lg:hidden"
                    src="../../logo.png"
                    alt="Your Company"
                  />
                  <div>
                  The Finhuntt
                  </div>
                  <img
                    className="hidden h-8 w-auto lg:block"
                    src="../../logo.png"
                    alt="Your Company"
                  />
                </div>
                {/* <div className="hidden sm:ml-6 sm:block no-underline "> */}
                  <div className="navbar_right sm:flex space-x-4 hidden">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current ? 'bg-gray-900 text-white no-underline' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                          'rounded-md px-3 py-2 text-sm font-medium no-underline '
                        )}
                        aria-current={item.current ? 'page' : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                {/* </div> */}
              </div>
              
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pb-3 pt-2">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                    'block rounded-md px-3 py-2 text-base font-medium'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}
